import './TileButton.scss';

import * as React from 'react';

import SlButton from '@shoelace-style/shoelace/dist/react/button';

export interface TileButtonProps
  extends Pick<
    React.ComponentProps<typeof SlButton>,
    'onClick' | 'disabled' | 'aria-label'
  > {
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  className?: string;
}

export const TileButton = ({
  icon,
  title,
  description,
  className,
  ...rest
}: TileButtonProps) => {
  return (
    <div className="flex tile-button" data-testid="tile-button">
      <SlButton className={`flex ${className}`} {...rest}>
        <div slot="prefix">{icon}</div>
        <div>{title}</div>
        <div slot="suffix">{description}</div>
      </SlButton>
    </div>
  );
};
